import { render, staticRenderFns } from "./storTable.vue?vue&type=template&id=1124e114&scoped=true&"
import script from "./storTable.vue?vue&type=script&lang=js&"
export * from "./storTable.vue?vue&type=script&lang=js&"
import style0 from "./storTable.vue?vue&type=style&index=0&id=1124e114&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1124e114",
  null
  
)

export default component.exports